import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapActions } from 'vuex';
export default {
  data: function data() {
    return {
      currentValue: ''
    };
  },
  computed: _objectSpread({}, mapState('d2admin/size', ['value'])),
  watch: {
    value: {
      handler: function handler(val) {
        this.currentValue = val;
      },
      immediate: true
    }
  },
  methods: _objectSpread({}, mapActions('d2admin/size', ['set']))
};